/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SideNavComponent } from "./side-nav/side-nav.component";
import { TemplateComponent } from "./template.component";
import { HeaderComponent } from "./header/header.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [SideNavComponent, TemplateComponent, HeaderComponent],
  exports: [TemplateComponent],
  imports: [CommonModule, FontAwesomeModule, RouterModule]
})
export class ProvisioningTemplateModule {}
